import { render, staticRenderFns } from "./EditParticipantForm.vue?vue&type=template&id=589a2a08&"
import script from "./EditParticipantForm.vue?vue&type=script&lang=js&"
export * from "./EditParticipantForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports